import { blackbaudUserInitialState } from './blackbaudUser.initialState';
import { path, pathOr } from 'ramda';
import { createSelector } from 'reselect';

export const getPendingBlackbaudUserUpdate = state =>
	path(['blackbaudUser', 'pendingUpdate'], state);
export const getPendingBlackbaudUserCreate = state =>
	path(['blackbaudUser', 'pendingCreate'], state);
export const getPendingBlackbaudUsers = state => ({
	update: getPendingBlackbaudUserUpdate(state),
	create: getPendingBlackbaudUserCreate(state),
});

export const getBlackbaudUserErrorUpdate = state => path(['blackbaudUser', 'updateError'], state);
export const getBlackbaudUserErrorCreate = state => path(['blackbaudUser', 'createError'], state);
export const getBlackbaudUserErrors = state => ({
	update: getBlackbaudUserErrorUpdate(state),
	create: getBlackbaudUserErrorCreate(state),
});

export const getBlackbaudUserById = (state, id) =>
	pathOr({}, ['blackbaudUser', 'entities'], state)[id] || blackbaudUserInitialState;
export const getEntities = state => path(['blackbaudUser', 'entities'], state);
export const getBlackbaudUsers = createSelector(getEntities, entities => Object.values(entities));



// WEBPACK FOOTER //
// ./src/redux/blackbaudUsers/blackbaudUser.selector.js